var React = require('react');

function PlayAlt (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2ZM0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M22.3999 16L12.7999 21.5425V10.4574L22.3999 16Z","fill":"currentColor","key":1})]);
}

PlayAlt.defaultProps = {"fill":"currentColor","width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = PlayAlt;

PlayAlt.default = PlayAlt;
